import { IResponse } from "models";

export enum ActionType {
  DUPLICATE_QUESTION = "action/DUPLICATE_QUESTION",
  DUPLICATE_QUESTION_SUCCESS = "action/DUPLICATE_QUESTION_SUCCESS",
  DUPLICATE_QUESTION_ERROR = "action/DUPLICATE_QUESTION_ERROR",
  DUPLICATE_QUESTION_RESET = "action/DUPLICATE_QUESTION_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDuplicateQuestionPayload {
  id: number;
}

export interface DuplicateQuestionResponse extends IResponse {}
